import { AmazonS3LocationAdapter } from 'app/model/adapters/datasets/location/amazon-s3.location.adapter';
import {
    AdapterRegistry,
    IModel,
    Metamodel,
    SapDatasphereForAmazonS3Location
} from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SapDatasphereForAmazonS3Location)
})
export class SapDatasphereForAmazonS3LocationAdapter extends AmazonS3LocationAdapter {
    protected model(): IModel {
        return SapDatasphereForAmazonS3Location.MODEL;
    }
}
